import React from 'react';
import SectionsInfo from '../SectionsInfo';

function Banner({
  title, description, way, body, image,
}) {
  return (
    <div className="container medium">
      <div className="about-us__banner">
        <div className="about-us__banner-text-content">
          <div className="about-us__banner-text-content-top">
            <p className="about-us__banner-text-content-explore">{way}</p>
            <SectionsInfo
              center={false}
              isSlider={false}
              isPartner={false}
              title={title}
              isAboutUs
              description={body}
            />
          </div>
          <div className="about-us__banner-text-content-bottom">
            <p className="about-us__banner-text-content-bottom-text" dangerouslySetInnerHTML={{ __html: description }} />
          </div>
        </div>
        <div className="about-us__banner-image">
          <img src={image} alt="banner" />
        </div>
      </div>
    </div>
  );
}

export default Banner;
